import React, { useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { toast } from 'react-toastify'

import { showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { Box, Button, Flex, Image, Input, Link, Text } from '@chakra-ui/react'
import { useDispatch } from 'react-redux'
import useAuth from '../../useAuth'

const NewPasswordForm = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const id = searchParams.get('id')
  const [isSuccess, setIsSuccess] = useState(false)
  const passwordRef = useRef()

  const dispatch = useDispatch()
  const { useResetPassword } = useAuth()
  const resetPassword = useResetPassword()

  const handleSubmit = async () => {
    const passwordValue = passwordRef.current.value || ''

    if (passwordValue === '') {
      toast.error('Please enter your email.')
      return
    }

    try {
      dispatch(showLoadingOverlay)
      await resetPassword.mutateAsync({ password: passwordValue, userId: id, token })
      setIsSuccess(true)
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(showLoadingOverlay)
    }
  }
  if (!id || !token) {
    return <>Missing Token / User Id</>
  }
  return (
    <Flex direction="column" bg="white" p={[6, 12]} minW={[0, 500]} alignItems={'center'} gap="3">
      <Image
        w="150px"
        objectFit="cover"
        src={
          'https://www.siemens-home.bsh-group.com.hk/store/medias/sys_master/root/h63/hcd/10563534323742/GL-SIE-Logo-Siemens-Petrol-RGB-BSH-Reshape-2021.png'
        }
      />

      {!isSuccess && (
        <>
          <Text fontSize="xl">Choose a new password</Text>

          <Box alignSelf={'start'} w="100%" mt="5">
            <Input ref={passwordRef} color="blackAlpha.600" type={'password'} placeholder={'Enter new password'} />
          </Box>
          <Button bg="#099d9d" color="white" w="100%" onClick={handleSubmit}>
            Continue
          </Button>
        </>
      )}

      {isSuccess && (
        <>
          <Text fontSize="xl">Reset Password Success !</Text>
          <Link color="#099d9d" href="/auth/login">
            Go back to Login
          </Link>
        </>
      )}
    </Flex>
  )
}
export default NewPasswordForm
